import {
  DoubleSide,
  FrontSide,
  LineBasicMaterial,
  MeshBasicMaterial,
} from 'three';
import type { Color } from 'three';

//eslint-disable-next-line no-restricted-imports
import { defaultColor } from './colors';

//A cache for double sided mesh material
const doubleSidedMaterialByColor = new WeakMap<Color, MeshBasicMaterial>();

//getDoubleSideMaterial(): gets material from cache if it exists, or creates/caches/returns new material
export const getDoubleSideMaterial = (
  color?: Color | null,
): MeshBasicMaterial => {
  let material: MeshBasicMaterial | undefined = color
    ? doubleSidedMaterialByColor.get(color)
    : undefined;
  if (!material) {
    material = new MeshBasicMaterial({
      color: color ?? defaultColor,
      side: DoubleSide,
    });
    doubleSidedMaterialByColor.set(color ?? defaultColor, material);
  }
  return material;
};

const frontSidedMaterialByColor = new WeakMap<Color, MeshBasicMaterial>();

//getFrontSideMaterial(): gets material from cache if it exists, or creates/caches/returns new material
export const getFrontSideMaterial = (
  color?: Color | null,
): MeshBasicMaterial => {
  let material: MeshBasicMaterial | undefined = color
    ? frontSidedMaterialByColor.get(color)
    : undefined;
  if (!material) {
    material = new MeshBasicMaterial({
      color: color ?? defaultColor,
      side: FrontSide,
    });
    frontSidedMaterialByColor.set(color ?? defaultColor, material);
  }
  return material;
};

const basicMaterialByColor = new WeakMap<Color, MeshBasicMaterial>();

//getMeshBasicMaterial(): gets material from cache if it exists, or creates/caches/returns new material
export const getMeshBasicMaterial = (
  color?: Color | null,
): MeshBasicMaterial => {
  let material: MeshBasicMaterial | undefined = color
    ? basicMaterialByColor.get(color)
    : undefined;
  if (!material) {
    material = new MeshBasicMaterial({
      color: color ?? defaultColor,
    });
    basicMaterialByColor.set(color ?? defaultColor, material);
  }
  return material;
};

//A cache of line material
const lineMaterialByColorAndLineWidth = new WeakMap<
  Color,
  Map<number | undefined, LineBasicMaterial>
>();

//getLineMaterial(): gets material from cache if it exists, or creates/caches/returns new LineBasicMaterial
export const getLineMaterial = (
  color?: Color | null,
  linewidth?: number,
): LineBasicMaterial => {
  let lineMaterialByLineWidth:
    | Map<number | undefined, LineBasicMaterial>
    | undefined = lineMaterialByColorAndLineWidth.get(color ?? defaultColor);
  if (!lineMaterialByLineWidth) {
    lineMaterialByLineWidth = new Map();
    lineMaterialByColorAndLineWidth.set(
      color ?? defaultColor,
      lineMaterialByLineWidth,
    );
  }

  let material: LineBasicMaterial | undefined =
    lineMaterialByLineWidth.get(linewidth);

  if (!material) {
    material = new LineBasicMaterial({
      color: color ?? defaultColor,
    });
    lineMaterialByLineWidth.set(linewidth, material);
  }
  return material;
};
